import React from 'react';
import { useContext, useState } from 'react';
import Button from "react-bootstrap/Button";
import { Link } from "wouter";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faBuilding } from '@fortawesome/free-solid-svg-icons'

import adminStatusContext from '../context/adminStatusContext'
import QuizApi from '../QuizApi';
import { absURL } from '../utils';

export default function AdminHeader() {

  const ctx = useContext(adminStatusContext);
  const [loading, setLoading] = useState(false);

  const logout = function() {

    const fn = async () => {

      if (loading) {
        return;
      }

      setLoading(true);

      try {
        const result = await QuizApi.userLogout();
        if (result && result.success) {
          window.location.reload();
        }

      } catch(e) {
        console.log(e);
      }

      setLoading(false);
    };

    fn();
  };

  return (
    <div>
      <div className="adminHeader mb-2">

        <Link href={absURL("/admin")} className="adminHeaderBrand">
          <img src="/favicon.ico" className="adminHeaderBrandIcon" alt="" />
          <span className="adminHeaderBrandText">Bombab Quiz</span>
        </Link>

        <div className="adminHeaderRight">
          {ctx.orgHasLogo
            ? <img src={`/api/org/${ctx.orgId}/logo`} className="adminHeaderOrgLogo" alt="" />
            : <FontAwesomeIcon icon={faBuilding} className="adminHeaderOrgIcon" />
          }
          {ctx.orgName && <span className="adminHeaderOrgName">{ctx.orgName}</span>}

          <span className="adminHeaderDivider" />

          {ctx.isSuperUser &&
            <Link href={absURL("/admin/super/organizations")}>
              <Button size="sm" variant="outline-light" className="mr-2">Superadmin</Button>
            </Link>
          }

          <FontAwesomeIcon icon={faUser} />
          <span className="ml-2">{ctx.userName}</span>
          <Button size="sm" variant="outline-light" className="ml-2" onClick={logout}>
            Logga ut
          </Button>
        </div>

      </div>

      {ctx.isFreeTier &&
        <div className="alert alert-warning py-1 px-3 mb-2" style={{ fontSize: "0.9rem" }}>
          Gratiskonto — kontakta <a href="mailto:info@bombab.se">info@bombab.se</a> för att uppgradera till Premium.
        </div>
      }
    </div>
  );
};